import { defaultOptions } from './traversable/defaultOptions';
import { getTraversable } from './traversable/getTraversable';
import { traversableToJSON } from './traversableToJSON';
/**
 * Parse an ArrayBuffer or Uint8Array representing an XML and return an object
 * @param xmlData
 * @param options
 */
export function parse(xmlData, options = {}) {
    if (typeof xmlData === 'string') {
        const encoder = new TextEncoder();
        xmlData = encoder.encode(xmlData);
    }
    if (!ArrayBuffer.isView(xmlData)) {
        xmlData = new Uint8Array(xmlData);
    }
    const realOptions = { ...defaultOptions, ...options };
    const traversable = getTraversable(xmlData, realOptions);
    return traversableToJSON(traversable, realOptions);
}
//# sourceMappingURL=parse.js.map